import { RepositoryImplGenerico } from "../../../shared/Infraestructure/RepositoryImplGenerico";
import { IServiceChangePasswordRequest } from "../Domain/IServiceChangePassword";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class RepositoryImplMain extends RepositoryImplGenerico<any> implements RepositoryMain {
    public async postChangePassword(params: IServiceChangePasswordRequest): Promise<any> {
        const _params = {
            IdProceso: 7,
            data: params
        }
        await this.service.call<any>("POST", `${this.urlBase}/usuario/updatePassword`, JSON.stringify(_params), "bearer", "json", "json", {}, 0);
    }

    public async onLogout(): Promise<void> {
        await this.dbLocal.clearStore(['Comparativo', 'Factura', 'RequerimientoSistema', 'RequerimientoCompra', 'SolicitudCajaChica', 'RendicionGastosCajaChica', 'CTAnticipo', 'CTFlujosOT', 'CTFlujosDelegacion', 'CTMoneda', 'CTOT', 'CTPersonal', 'CTProveedor', 'CTProyectos', 'CTServicio', 'CTTipoCambio', 'CTTipoDocumento', 'CTTipoDocumentoTributario', 'CTVAT']);
    }
}